import { UserDto } from '@core/common/user-dto';

export class AuthState {
  user?: UserDto;
}
